/**
 * Mesh parser utility.
 *
 * Parses mesh data from ArrayBuffer into vtkPolyData.
 * Supports legacy VTK ASCII format (.vtk).
 */

// @ts-expect-error — vtk.js LegacyAsciiParser has no type declarations
import vtkLegacyAsciiParser from '@kitware/vtk.js/IO/Legacy/LegacyAsciiParser';

/**
 * Parse a VTK legacy ASCII mesh ArrayBuffer into vtkPolyData.
 *
 * Uses vtk.js LegacyAsciiParser directly to parse the text content.
 * The parser populates a dataModel whose `.dataset` field is a vtkPolyData instance.
 *
 * @param buffer - Raw mesh file bytes (VTK legacy ASCII format)
 * @returns vtkPolyData instance
 * @throws Error if parsing fails
 */
export function parseMesh(buffer: ArrayBuffer): unknown {
    const text = new TextDecoder().decode(buffer);
    const dataModel = vtkLegacyAsciiParser.parseLegacyASCII(text);
    if (!dataModel?.dataset) {
        throw new Error('Failed to parse VTK mesh: no dataset produced');
    }
    return dataModel.dataset;
}
